module.exports = __webpack_public_path__ + "static/media/combat.be323064.jpg";